import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import section from '@/api/section'
import journal from '@/api/journal'
import { reviewerApply } from '@/api/reviewer'
import { settingCountry, settingOption } from '@/api/setting'
import Reject from './reject.dialog.vue'
import help from '@/utils/help'
export default {
  components: { Reject },
  data() {
    return {
      params: {
        affiliations: [''],
        reviewJournals: [''],
        keywords: [],
        handle: ''
      },
      re_edit: true,
      showReason: false,
      rules: {},
      countryList: [],
      categoryList: [],
      journalList: [],
      download: help.download,
      reviewFrequencyList: [],
      titleList: [],
      degreesList: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      user: 'getUser',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
      reviewFrequency: 'getReviewFrequency',
      degree: 'getDegree',
      country: 'getCountry'
    })
  },
  watch: {
    user: {
      handler(val) {
        const res = JSON.parse(JSON.stringify(val))
        const {
          titleCode,
          firstName,
          lastName,
          countryCode,
          city,
          degreeCode,
          categoryIdList,
          affiliation,
          website,
          reviewJournal,
          keyword,
          journalIdList,
          researchGate
        } = res

        this.params = Object.assign(this.params, {
          titleCode,
          firstName,
          lastName,
          countryCode,
          city,
          degreeCode,
          categoryIdList: categoryIdList || [],
          affiliation,
          affiliations: affiliation ? affiliation.split(';') : [''],
          website,
          reviewJournal,
          reviewJournals: reviewJournal ? reviewJournal.split(';') : [''],
          keyword,
          keywords: keyword ? keyword.split(';') : [],
          journalIdList: journalIdList || [],
          researchGate
        })
        if (this.params.handle) {
          this.re_edit = false
        } else {
          this.re_edit = true
        }
        this.getQuery()
      },
      immediate: true
    }
  },
  mounted() {
    this.getRules()
    this.getSection()
    this.getJournalList()
    this.countrySearch()
    this.getData()
  },
  methods: {
    async getQuery() {
      this.params = Object.assign(this.params, await reviewerApply.getByUser())
      const {
        categoryList,
        journalList,
        keyword,
        affiliation,
        reviewJournal
      } = this.params
      this.params.affiliations = affiliation ? affiliation.split(';') : ['']
      this.params.reviewJournals = reviewJournal ? reviewJournal.split(';') : []
      this.params.categoryIdList = categoryList
        ? categoryList.map(item => {
            return item.id
          })
        : []
      this.params.keywords = keyword ? keyword.split(';') : []
      this.params.journalIdList = journalList
        ? journalList.map(item => {
            return item.id
          })
        : []
      if (this.params.handle) {
        this.re_edit = false
      } else {
        this.re_edit = true
      }
    },
    async getSection() {
      this.categoryList = await section.getAll()
    },
    // 获取journalist列表
    async getJournalList() {
      this.journalList = await journal.getAll({
        released: true
      })
    },
    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },
    async getData() {
      const reviewFrequencyList = await settingOption.get({
        type: 'REVIEW_FREQUENCY'
      })
      const degreesList = await settingOption.get({ type: 'DEGREE' })
      const titleList = await settingOption.get({ type: 'TITLE' })
      this.degreesList = degreesList
      this.titleList = titleList
      this.reviewFrequencyList = reviewFrequencyList
    },
    addMore(key) {
      this.params[key].push('')
    },
    delMore(key, index) {
      if (this.params[key].length === 1) {
        return
      }
      this.params[key].splice(index, 1)
    },
    getMore(key) {
      const arr = []
      this.params[key + 's'].forEach(item => {
        if (item) {
          arr.push(item)
        }
      })
      this.params[key] = arr.join(';')
    },
    async submit() {
      const flag = this.$refs['reviewers-menu-volunteer-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          keyword: this.params.keywords.join(';')
        })
        this.params = Object.assign(this.params, await reviewerApply.add(data))
        const { categoryList, journalList, keyword } = this.params
        this.params.categoryIdList = categoryList
          ? categoryList.map(item => {
              return item.id
            })
          : []
        this.params.keywords = keyword ? keyword.split(';') : []
        this.params.journalIdList = journalList
          ? journalList.map(item => {
              return item.id
            })
          : []
        this.$message.success({
          title: 'Success',
          content: 'Reviewer application submitted successfully!'
        })
        this.re_edit = false
      }
    },
    async handleUpload(key, files) {
      const file = files[0]
      const pdfFiles = ['rcv']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `publisher/${this.publisherId}/reviewer-board/${
          this.user.id
        }/${key}/${help.guid()}`
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, key + 'Name', file.name)
      this.$set(this.params, key, url)
    },

    delFile(key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },

    viewReason() {
      this.showReason = true
    },
    reEdit() {
      this.showReason = false
      this.re_edit = true
    },
    cancel() {
      this.showReason = false
    },
    getRules() {
      this.rules = {
        titleCode: [
          {
            required: true,
            message: 'Title' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        firstName: [
          {
            required: true,
            message: 'First Name' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        lastName: [
          {
            required: true,
            message: 'Last Name' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        countryCode: [
          {
            required: true,
            message: 'Country' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        affiliation: [
          {
            required: true,
            message: 'Affiliation' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        affiliationAddress: [
          {
            required: true,
            message:
              'Affiliations Address' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        hindex: [
          {
            required: true,
            message: 'H-index' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        hindexUrl: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'H-index Url'
          }
        ],
        website: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'Website'
          }
        ],
        keywords: [
          {
            required: true,
            min: 1,
            message: 'Keywords' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        rcv: [
          {
            required: true,
            message: 'CV' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        journalIdList: [
          {
            required: true,
            min: 1,
            message:
              'Journal(s) Would Like to Review' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        frequencyCode: [
          {
            required: true,
            message: 'Review Frequency' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    }
  }
}
